import React from "react";
import { Label } from "../../../components/ui/label";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../../../components/ui/select";

// EMAILS-IMPL-009: the two REAL governed status vocabularies shared across
// all 9 Asset families (email_marketing_assets.py) -- reconfirmed directly
// against the model file during this checkpoint, not assumed. Never a
// single universal dropdown: a 6-state family's Select must never be able
// to select "Control" (5-state only), and a 5-state family's Select must
// never be able to select "Active"/"Archived" (6-state only).
export const FIVE_STATE_STATUS_VALUES = ["Draft", "Review", "Approved", "Control", "Retired"];
export const SIX_STATE_STATUS_VALUES = ["Draft", "Review", "Approved", "Active", "Retired", "Archived"];

// Mirrors the per-panel `StatusField` pattern EMAILS-IMPL-007's
// AnglesPanel/CampaignsPanel/AudiencesPanel each defined locally (identical
// markup, only the values array differed) -- with 9 more families now
// needing the same field, factoring it out once avoids reproducing that
// same Select markup 9 additional times.
export default function StatusSelectField({ id, label = "Status", value, onChange, values, testId }) {
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id={id} data-testid={testId}>
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {values.map((s) => (
            <SelectItem key={s} value={s} data-testid={`${testId}-option-${s}`}>
              {s}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
